<template>
  <div class="jbdfyh-wrap">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick" @changeCompany="changeCompany"></tab-tree>
      </div>
      <div class="content">
        <div class="search-box box">
          <time-search ref="timeSearch" :control="{ data: timeData }" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick"></time-search>
        </div>
        <div class="grid-content">
          <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
          <div class="box1 boxYl">
            <el-row>
              <el-col :span="24">
                <div class="bg-purple">
                  <div class="box1 bgbox">
                    <div class="contant_box setHeight dn-content-bg">
                      <div style="height:50%">
                        <bardf :barDate2="barDate2"></bardf>
                      </div>
                      <div class="block">
                        <div class="sliderText">功率因数调整</div>
                        <div class="slider-box">
                          <el-slider
                            class="slider"
                            style="margin-bottom:15px"
                            v-model="sliderDemo"
                            @change="sliderChage"
                            show-stops
                            :marks="{
                              0: '0',
                              10: '0.1',
                              20: '0.2',
                              30: '0.3',
                              40: '0.4',
                              50: '0.5',
                              60: '0.6',
                              70: '0.7',
                              80: '0.8',
                              90: '0.9',
                              100: '1.00'
                            }"
                          ></el-slider>
                        </div>
                      </div>
                      <div style="text-align: center;">力调电费合理性分析表(功率因数:{{ sliderDemo / 100 }})</div>
                      <div style="margin-top:10px;height: calc(50% - 110px);">
                        <nk-table :showPage="false" :columns="columns" :maxHeight="1600" :data="tableData1"></nk-table>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import BtnShow from '@/components/common/BtnShow.vue'
import TimeSearch from '@/components/common/TimeSearch.vue'
import NkTable from '@/components/common/NkTable'
import Bardf from '../nygl/pages/bardf'
import Guan from '../nygl/pages/guan'
import * as utils from '@/utils/index.js'
import * as configData from '@/config/data.js'
import * as handleData from '@/utils/handleData.js'
import tree from '@/utils/tree.js'
import TabTree from '@/components/common/TabTree.vue'
import { isNull, isUndefined } from 'util'
import dateTool from '@/utils/dateTool'
import ResizeContainer from '@/components/common/resizeContainer.vue'
export default {
  data() {
    return {
      tabShow: true, //左边的树是否显示
      viewTreeData: [], //树数据
      sliderDemo: 90,
      treeTabObj: null,
      // checkedKeys: [],
      treeData: {},
      dataType: '0',
      elem: {
        dataType: '0',
        dateType: '0',
        fromDate: '',
        toDate: ''
      },
      barDate1: {
        xdata: ['原力调电费', '调节力调电费'],
        data: ['', ''],
        timeTitle: ''
      },
      timeElem: {}, //当前的时间参数
      timeData: [
        {
          type: 'month',
          label: '月'
        }
      ],
      barDate2: {},
      pie: {}, //饼图数据
      pointCode: '100229',
      pointNumber: '0',
      measureId: '', //计量点
      apiArr: [],
      columns: [
        { prop: 'dfValue', width: 200, label: '' },
        { prop: 'fValue', label: '峰期电(元)' },
        { prop: 'pValue', label: '平期电(元)' },
        { prop: 'gValue', label: '谷期电(元)' },
        { prop: 'eleFree', label: '电度电费' },
        { prop: 'sliderDemo', label: '功率因数' },
        { prop: 'Forceadjustment', label: '力调系数' },
        { prop: 'ForceadjustmentEle', label: '力调电费(元)' }
      ],
      tableData: [
        {
          dfValue: '',
          fValue: '',
          pValue: '',
          gValue: '',
          ForceadjustmentEle: '',
          eleFree: '',
          Forceadjustment: ''
        },
        {
          dfValue: '',
          fValue: '',
          pValue: '',
          gValue: '',
          ForceadjustmentEle: '',
          eleFree: '',
          Forceadjustment: ''
        },
        {
          dfValue: '',
          fValue: '',
          pValue: '',
          gValue: '',
          ForceadjustmentEle: '',
          eleFree: '',
          Forceadjustment: ''
        }
      ], //电费表格
      tableData1: [], //电费表格
      bl: [],
      df: [], //功率调整比例
      Forceadjustment: '', //力调系数
      eleFree: ''
    }
  },
  async created() {
    let vm = this
    vm.gerDf()
  },
  methods: {
    async changeCompany(companyId) {
      //获取树数据
      let vm = this
      let res = await vm.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, '/nyyh/forceEle', null)
      vm.viewTreeData = utils.findDataByParam('viewTree', true, res.data) //数据赋值
    },
    tabTreeDefault(e) {
      //首次加载树时执行，保留默认的树选择
      let vm = this
      vm.measureId = e.measureId
      vm.getData() //获取数据
    },
    tabTreeClick(e) {
      //树节点点击的时候触发
      let vm = this
      vm.measureId = e.measureId
      vm.getData() //获取数据
    },
    gerDf() {
      //获取功率调整比例
      let vm = this
      for (let i = 0; i < configData.DF.length; i++) {
        if (configData.DF[i].item == 0.9) {
          vm.df = configData.DF[i].data
        }
      }
      console.log('🚀 ~ file: forceEle.vue:206 ~ gerDf ~ vm.df:', vm.df)
      for (let i = 0; i < vm.df.length; i++) {
        vm.df[i].factor = parseFloat(vm.df[i].factor)
        let elem = vm.df[i]
        if (elem.factor == vm.sliderDemo / 100) {
          vm.Forceadjustment = elem.value
          return
        }
      }
    },
    formatTooltip(val) {
      //功率因数滑块
      let vm = this
      vm.gerDf()
      return val / 100
    },
    sliderChage(e, item) {
      let vm = this
      let value = e / 100 //功率因数
      let itemDF = configData.DF.find(obj => obj.item == '0.90')
      let coefficient = 0
      if (itemDF) {
        coefficient = itemDF.data.find(obj => obj.factor == value).value
      }
      vm.tableData1[1].sliderDemo = value
      vm.tableData1[1].Forceadjustment = coefficient + '%'
      vm.tableData1[1].ForceadjustmentEle = ((coefficient / 100) * vm.tableData1[0].eleFree).toFixed(2)
      vm.tableData1[2].ForceadjustmentEle = (vm.tableData1[0].ForceadjustmentEle - vm.tableData1[1].ForceadjustmentEle).toFixed(2)
      let str = ''
      if (vm.tableData1[2].ForceadjustmentEle > 0) {
        str = '奖励'
      } else {
        str = '损失'
      }
      vm.tableData1[2].ForceadjustmentEle = str + Math.abs(vm.tableData1[2].ForceadjustmentEle)
      let chartData = JSON.parse(JSON.stringify(vm.barDate2))
      chartData.data[1] = vm.tableData1[1].ForceadjustmentEle
      vm.barDate2 = chartData
    },
    timeControlChange(e) {
      //时间下拉框切换时触发
      let vm = this
      vm.timeElem = e
    },
    TimeControlClick(e) {
      //时间点击查询时
      let vm = this
      vm.timeElem = e
      vm.getData()
    },
    getData() {
      //查询事件
      let vm = this
      vm.barDate1.timeTitle = vm.timeElem.startTime + '~' + vm.timeElem.endTime
      vm.apiArr = []
      const dateObj = {
        day: 'Hour',
        week: 'Day',
        month: 'Month',
        year: 'Month'
      }
      vm.apiArr.push(
        vm.$api.quantity[`getSpentMoney${dateObj[vm.timeElem.dateType]}`](
          [
            {
              measureId: vm.measureId,
              pointCode: vm.pointCode,
              pointNumber: vm.pointNumber
            }
          ],
          vm.timeElem.startTime,
          vm.timeElem.endTime,
          '',
          1
        ) //峰，平，谷。总费
      )
      vm.apiArr.push(vm.$api.measuring.getMeasuringValueMaxMinMonth(vm.measureId, vm.timeElem.startTime, vm.timeElem.endTime, '219', vm.pointNumber))
      vm.getEDate()
    },
    timeChabge(bdata, resData) {
      //根据接口返回的time识别，转换 bdata要转换的数据，resData接口数据
      for (let i = 0; i < bdata.length; i++) {
        //拿取峰平谷柱状图数据
        if (resData.length > 0) {
          for (let j = 0; j < resData.length; j++) {
            if (resData[j].time == bdata[i].time) {
              bdata[i].value = isNaN(resData[j].value) ? '' : resData[j].value.toFixed(2)
            }
          }
        }
      }
    },
    async getEDate() {
      //获取数据
      let vm = this
      let res = await Promise.all(vm.apiArr)
      if (res[1].data.length > 0) {
        vm.sliderDemo = Math.round(res[1].data[0].avg * 100)
      } else {
        vm.sliderDemo = 90
      }
      vm.gerDf()
      vm.tableData[0].dfValue = '原电费'
      vm.tableData[1].dfValue = '力调电费'
      vm.tableData[2].dfValue = '电费差值'
      const dataValue = res[0].data[0].data[0]
      if (!dataValue) {
        vm.barDate2 = {
          timeTitle: vm.barDate1.timeTitle
        }
        vm.tableData1.forEach(k => {
          Object.keys(k).forEach(key => {
            if (key !== 'dfValue') {
              k[key] = '-'
            }
          })
        })
        return
      }
      vm.tableData[0].eleFree = isNull(dataValue.value) ? '-' : dataValue.value.toFixed(2) //总电费电费
      vm.tableData[1].eleFree = isNull(dataValue.value) ? '-' : dataValue.value.toFixed(2) //总电费电费
      vm.tableData[2].eleFree = '-' //总电费电费
      let itemDF = configData.DF.find(obj => obj.item == '0.90')
      let coefficient = 0
      if (itemDF) {
        let zh = itemDF.data.find(obj => obj.factor == vm.sliderDemo / 100)
        if (zh) {
          coefficient = zh.value
        }
      }
      vm.tableData[0].Forceadjustment = coefficient + '%' //力调系数
      vm.tableData[1].Forceadjustment = coefficient + '%' //力调系数
      vm.tableData[2].Forceadjustment = '-' //力调系数
      if (vm.tableData[0].Forceadjustment == '-') {
        vm.tableData[0].ForceadjustmentEle = '-'
      } else {
        vm.tableData[0].ForceadjustmentEle = vm.tableData[0].eleFree == '-' ? '-' : ((coefficient / 100) * vm.tableData[0].eleFree).toFixed(2)
        vm.tableData[1].ForceadjustmentEle = vm.tableData[0].eleFree == '-' ? '-' : ((coefficient / 100) * vm.tableData[0].eleFree).toFixed(2)
      }
      if (vm.tableData[1].Forceadjustment != '-') {
        vm.tableData[2].ForceadjustmentEle = vm.tableData[1].ForceadjustmentEle - vm.tableData[0].ForceadjustmentEle //力调电费
      }
      vm.tableData[0].sliderDemo = vm.sliderDemo / 100
      vm.tableData[1].sliderDemo = vm.sliderDemo / 100
      if (res[1].data.length == 0) {
        vm.tableData[0].sliderDemo = '-'
      }
      vm.tableData[2].sliderDemo = '-'
      vm.eleFree = isNaN(res[0].data.value) ? '-' : (res[0].data.value * vm.Forceadjustment + res[0].data.value).toFixed(2) //暂存总电费电费
      let newDf = []
      for (let i = 0; i < dataValue.detail.length; i++) {
        if (dataValue.detail[i].model == 1) {
          newDf.push(dataValue.detail[i])
        }
      }
      if (newDf.length === 0) {
        this.$message('缺少峰平谷尖的计划模型!')
        return
      }
      let [f, p, g] = [null, null, null]
      newDf.forEach(item => {
        f = item.values?.peak?.value
        p = item.values?.plain?.value
        g = item.values?.valley?.value
      })
      vm.tableData[0].fValue = isNaN(f) ? '-' : f.toFixed(2) //峰
      vm.tableData[0].pValue = isNaN(p) ? '-' : p.toFixed(2) //平
      vm.tableData[0].gValue = isNaN(g) ? '-' : g.toFixed(2) //谷
      vm.tableData[1].fValue = isNaN(f) ? '-' : f.toFixed(2) //峰
      vm.tableData[1].pValue = isNaN(p) ? '-' : p.toFixed(2) //平
      vm.tableData[1].gValue = isNaN(g) ? '-' : g.toFixed(2) //谷
      vm.tableData[2].fValue = '-' //峰
      vm.tableData[2].pValue = '-' //平
      vm.tableData[2].gValue = '-' //谷
      vm.barDate1.data[0] = isNaN(dataValue.value) ? '-' : ((dataValue.value * vm.Forceadjustment) / 100).toFixed(2) //力调电费
      vm.barDate1.data[1] = isNaN(dataValue.value) ? '-' : ((dataValue.value * vm.Forceadjustment) / 100).toFixed(2) //调节力调电费
      vm.tableData1 = JSON.parse(JSON.stringify(vm.tableData))
      vm.barDate2 = JSON.parse(JSON.stringify(vm.barDate1))
    }
  },
  components: {
    Bardf,
    TimeSearch,
    Guan,
    NkTable,
    BtnShow,
    TabTree,
    ResizeContainer
  }
}
</script>
<style lang="scss">
.boxYl {
  .el-table th,
  .el-table tr {
    background-color: #fff;
    height: 50px;
  }
}
</style>
<style lang="scss" scoped>
.jbdfyh-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  padding: 23px;
  box-sizing: border-box;
  .tree-content {
    width: 100%;
    margin-right: 14px;
  }
  .content {
    position: relative;
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 100%;
    .search-box {
      height: 36px;
      .option {
        width: 150px;
        margin: 0 0 0 10px;
      }
    }
    .grid-content {
      position: absolute;
      width: 100%;
      bottom: 0;
      display: flex;
      flex-flow: column;
      top: 50px;
      .bg-purple {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.box1 {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.el-row {
  width: 100%;
  height: 100%;
  margin: 0 !important;
}
.el-col {
  border-radius: 4px;
  height: 100%;
}
.parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.tree_parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.treecontent {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
  box-sizing: border-box;
}
.bgbox {
  position: relative;
  padding-top: 0;
  box-sizing: border-box;
  padding: 0;
}
.time_box {
  width: 100%;
  padding: 5px 0;
  box-sizing: border-box;
  border-radius: 4px;
}
.contant_box {
  position: absolute;
  top: 0;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding: 10px;
  padding-bottom: 0px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #eee;
  border-radius: 5px;
  overflow: auto;
}
.box_btn {
  height: 40px;
  width: 100%;
  line-height: 40px;
  display: flex;
  align-items: flex-end;
  border-bottom: 2px solid #00368e;
}
.box_btn p {
  font-size: 14px;
  color: #000;
  height: 30px;
  width: 96px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #f5f5f5;
  border-bottom: none;
  cursor: pointer;
}
.box_btn .active {
  background: #00368e;
  color: #fff;
}
.box_con {
  position: absolute;
  top: 50px;
  bottom: 0px;
  width: 100%;
  display: flex;
}
.box_con_ {
  position: absolute;
  top: 45px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow: hidden;
}
.chart_box {
  position: absolute;
  top: 10px;
  width: 100%;
  height: 600px;
  overflow: hidden;
}
.table_box {
  position: absolute;
  top: 615px;
  width: 100%;
  height: auto;
}
.charts {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.ys {
  font-size: 16px;
  margin-left: 560px;
  margin-top: 25px;
}
.elechart_box {
  width: 100%;
  height: auto;
}
.eletable_box {
  width: 100%;
  height: auto;
}
.block {
  display: flex;
  flex-flow: row;
  margin-top: 20px;
}
.sliderText {
  // display:flex;
  flex: 1;
  text-align: center;
  line-height: 53px;
}
.slider-box {
  //   display:flex;
  flex: 7;
  padding: 0 20px;
  box-sizing: border-box;
}

::v-deep .el-slider__bar {
  background-color: #0080ff;
}
</style>
